import React from 'react';

import { EDSButton } from '@gehc-eds-react/eds-button';

import { EDSTextField } from '@gehc-eds-react/eds-text-field';

import { EDSIcon } from '@gehc-eds-react/eds-icon';

export const EditSourceModal = ({

    isOpen,

    editPrefix,

    setEditPrefix,

    editDisplayName,

    setEditDisplayName,

    isUpdatingSource,

    onClose,

    onSave

}) => {

    if (!isOpen) return null;

    return (
        <div

            style={{

                position: 'fixed',

                inset: 0,

                backgroundColor: 'rgba(17, 24, 39, 0.45)',

                display: 'flex',

                alignItems: 'center',

                justifyContent: 'center',

                zIndex: 2100,

                padding: '16px'

            }}

            onClick={onClose}
        >
            <div

                role="dialog"

                aria-modal="true"

                aria-labelledby="edit-source-title"

                onClick={(event) => event.stopPropagation()}

                style={{

                    width: '100%',

                    maxWidth: '520px',

                    backgroundColor: '#fff',

                    borderRadius: '14px',

                    boxShadow: '0 24px 60px rgba(17, 24, 39, 0.22)',

                    overflow: 'hidden'

                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '20px 24px', borderBottom: '1px solid #edeff2' }}>
                    <div

                        style={{

                            width: '38px',

                            height: '38px',

                            borderRadius: '9px',

                            background: 'linear-gradient(135deg, #6D55B6 0%, #6C54B4 100%)',

                            display: 'flex',

                            alignItems: 'center',

                            justifyContent: 'center',

                            flexShrink: 0

                        }}
                    >
                        <EDSIcon iconName="ico-edit-16" style={{ color: '#fff' }} />
                    </div>
                    <h4 id="edit-source-title" style={{ margin: 0, fontSize: '18px', fontWeight: 700, color: '#111827' }}>

                        Edit Source
                    </h4>
                </div>
                <div style={{ display: 'grid', gap: '12px', padding: '20px 24px' }}>
                    <EDSTextField

                        name="edit-prefix"

                        label={{ width: '', position: 'top', text: 'Prefix' }}

                        value={editPrefix}

                        placeholder="Enter prefix"

                        isRequired={false}

                        width="100%"

                        type="text"

                        onEDSTextFieldChange={(e) => setEditPrefix(e.target.value)}

                    />
                    <EDSTextField

                        name="edit-display-name"

                        label={{ width: '', position: 'top', text: 'Display Name' }}

                        value={editDisplayName}

                        placeholder="Enter display name"

                        isRequired={false}

                        width="100%"

                        type="text"

                        onEDSTextFieldChange={(e) => setEditDisplayName(e.target.value)}

                    />
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', padding: '16px 24px', backgroundColor: '#fafbfc', borderTop: '1px solid #edeff2' }}>
                    <EDSButton variant="secondary" type="button" label="Cancel" onEDSButtonClick={onClose} isDisabled={isUpdatingSource} />
                    <EDSButton

                        variant="primary"

                        type="button"

                        label={isUpdatingSource ? 'Updating...' : 'Update'}

                        onEDSButtonClick={onSave}

                        isDisabled={isUpdatingSource}

                    />
                </div>
            </div>
        </div>

    );

};

export const DeleteSourceModal = ({ isOpen, sourceToDelete, isDeletingSource, onClose, onConfirm }) => {

    if (!isOpen || !sourceToDelete) return null;

    return (
        <div

            style={{

                position: 'fixed',

                inset: 0,

                backgroundColor: 'rgba(17, 24, 39, 0.45)',

                display: 'flex',

                alignItems: 'center',

                justifyContent: 'center',

                zIndex: 2000,

                padding: '16px'

            }}

            onClick={onClose}
        >
            <div

                role="dialog"

                aria-modal="true"

                aria-labelledby="delete-source-title"

                onClick={(event) => event.stopPropagation()}

                style={{

                    width: '100%',

                    maxWidth: '420px',

                    backgroundColor: '#fff',

                    borderRadius: '14px',

                    boxShadow: '0 24px 60px rgba(17, 24, 39, 0.22)',

                    padding: '24px'

                }}
            >
                <div

                    style={{

                        width: '38px',

                        height: '38px',

                        borderRadius: '9px',

                        background: '#fbeaea',

                        display: 'flex',

                        alignItems: 'center',

                        justifyContent: 'center',

                        marginBottom: '14px'

                    }}
                >
                    <EDSIcon iconName="ico-trash-16" style={{ color: '#c62828' }} />
                </div>
                <h4 id="delete-source-title" style={{ margin: 0, marginBottom: '8px', fontSize: '18px', fontWeight: 700, color: '#111827' }}>

                    Deboard source?
                </h4>
                <p style={{ margin: '0 0 18px 0', color: '#555' }}>

                    Are you sure you want to deboard this source?
                </p>
                <p style={{ margin: '0 0 20px 0', color: '#333', fontWeight: 600 }}>

                    {sourceToDelete.account_id || '--'}
                </p>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                    <EDSButton variant="secondary" type="button" label="Cancel" onEDSButtonClick={onClose} isDisabled={isDeletingSource} />
                    <EDSButton

                        variant="primary"

                        type="button"

                        label={isDeletingSource ? 'Deboarding...' : 'Deboard'}

                        onEDSButtonClick={onConfirm}

                        isDisabled={isDeletingSource}

                    />
                </div>
            </div>
        </div>

    );

};
